import { useState, useEffect, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import classNames from 'classnames';
import NTMLoadingModal from "../../components/Modal/NTMLoadingModal";


export default function PageWithModal({
	loading, error, success, message, confirm, clear, ...props
}) {

	const [modal, setModal] = useState(null)
	const modalCode = useRef(-1)

	useEffect(() => {
		let newModal;
		let newModalCode;
		let closeModal = () => { clear(); setModal(null) }

		if (loading) {
			newModal = <NTMLoadingModal />;
			newModalCode = 1;
		} else if (error) {
			newModal = <SweetAlert type={'error'} title={'Errore'} onConfirm={closeModal} onCancel={closeModal}>{error}</SweetAlert>
			newModalCode = 2;
		} else if (success) {
			newModal = <SweetAlert type={'success'} title={"Operazione eseguita"} onConfirm={closeModal} onClose={closeModal} />
			newModalCode = 3;
		} else if (message) {
			newModal = <SweetAlert type={'success'} title={message} onConfirm={closeModal} onClose={closeModal} />
			newModalCode = 4;
		} else if (confirm) {
			let { type, title, message, buttonText, onConfirm } = confirm;
			newModal = <SweetAlert
				type={type || 'warning'}
				title={title || 'Confermi?'}
				showCancel
				cancelBtnText={"Annulla"}
				confirmBtnText={buttonText || 'Conferma'}
				onCancel={closeModal}
				onConfirm={() => { onConfirm(); closeModal() }}
				focusCancelBtn
			>
				{message}
			</SweetAlert>
			newModalCode = 5;
		} else {
			newModal = null;
			newModalCode = -1;
		}
		if (newModalCode !== modalCode.current) {
			setModal(newModal)
			modalCode.current = newModalCode
		}
	}, [loading, error, success, message, confirm, clear])

	let className = classNames("animated", "fadeIn", "container", props.className);

	return (
		<div className={className} style={props.style}>
			{modal}
			{props.children}
		</div>
	)
}
